export default "__VITE_ASSET__68a7c3cb__"